// API Configuration
// Central location for all API endpoints across the application

const BASE_URLS = {
    MAIN: "https://dbparity.fugetroncorp.com/api",
    TEST: "https://qa-dbparity.fugetroncorp.com:8844/api",
    DEV: "https://dev-dbparity.fugetroncorp.com:8843/api",
}

// Change this to DEV | TEST | MAIN based on the environment
const BASE_URL = BASE_URLS.MAIN;

// WebSocket base derived from the active HTTP base: https -> wss, http -> ws.
// Keeps the host/port/path in sync so switching DEV | TEST | MAIN also moves
// the socket. Adjust the `/comparisons/ws/...` path below to match whatever
// the backend actually exposes.
const WS_BASE = BASE_URL.replace(/^http/i, 'ws');

const CONNECTIONS_BASE = `${BASE_URL}/connections`;
const JOBS_BASE = `${BASE_URL}/comparisons`;
const REPO_BASE = `${BASE_URL}/github`;
const USERS_BASE = `${BASE_URL}/users`;

export const API_ENDPOINTS = {
    CONNECTIONS: {
        PUBLIC_KEY: `${CONNECTIONS_BASE}/crypto/public-key`,
        GET_ALL: `${CONNECTIONS_BASE}`,
        ADD: `${CONNECTIONS_BASE}`,
        TEST: `${CONNECTIONS_BASE}/test`,
        TEST_UPDATED: (id) => `${CONNECTIONS_BASE}/${id}/update-test`,
        UPDATE: (id) => `${CONNECTIONS_BASE}/${id}`,
        ACTIVATE: (id) => `${CONNECTIONS_BASE}/${id}/activate`,
        DEACTIVATE: (id) => `${CONNECTIONS_BASE}/${id}/deactivate`,
        DELETE: (id) => `${CONNECTIONS_BASE}/${id}`,
    },

    JOBS: {
        GET_ALL: `${JOBS_BASE}`,
        ACTIVE_CONNECTIONS: `${CONNECTIONS_BASE}/active_connections`,
        ACTIVE_GIT_CONNECTIONS: `${REPO_BASE}/connections/active`,
        SCHEMA_DROPDOWNS: `${JOBS_BASE}/schemas_dropdown`,
        SAVE: `${JOBS_BASE}/save`,
        SAVE_AND_RUN: `${JOBS_BASE}/save-and-run`,
        UPDATE: (id) => `${JOBS_BASE}/${id}`,
        UPDATE_AND_RUN: (id) => `${JOBS_BASE}/${id}/update-and-run`,
        DELETE: (id) => `${JOBS_BASE}/${id}`,
        START: (id) => `${JOBS_BASE}/${id}/run`,
        STOP: (id) => `${JOBS_BASE}/${id}/cancel`,
        GET_RUN: (runId) => `${JOBS_BASE}/runs/${runId}`,
        // Single shared, receive-only WebSocket for live job/run-status updates.
        // The token is passed as a query param because a browser WS handshake
        // can't carry an Authorization header; the server closes with 4401 if it
        // is missing / invalid / expired.
        JOB_STATUS_WS: (token) =>
            `${WS_BASE}/comparisons/ws/jobs${token ? `?token=${encodeURIComponent(token)}` : ''}`,
        GET_REPORT: (runId) => `${JOBS_BASE}/runs/${runId}/report`,
        DOWNLOAD_MIGRATION: (id) => `${JOBS_BASE}/runs/${id}/download/migration`,
        DOWNLOAD_ROLLBACK: (id) => `${JOBS_BASE}/runs/${id}/download/rollback`
    },

    REPOSITORIES: {
        REPOS_DROPDOWN: `${REPO_BASE}/repos`,
        BRANCHES_DROPDOWN: `${REPO_BASE}/branches`,
        GET_ALL: `${REPO_BASE}/connections`,
        ADD: `${REPO_BASE}/connections`,
        UPDATE: (id) => `${REPO_BASE}/connections/${id}`,
        DELETE: (id) => `${REPO_BASE}/connections/${id}`,
        PUSH_TO_GIT: (id) => `${REPO_BASE}/runs/${id}/push`,
    },

    // USERS: {
    //     GET_ALL: `${BASE_URL}/get_users`,
    //     GET_BY_ID: (id) => `${BASE_URL}/users/${id}`,
    //     CREATE: `${BASE_URL}/create_user`,
    //     UPDATE: (id) => `${BASE_URL}/update_user/${id}`,
    //     DELETE: (id) => `${BASE_URL}/delete_user/${id}`,
    //     ACTIVATE: (id) => `${BASE_URL}/users/${id}/activate`,
    //     DEACTIVATE: (id) => `${BASE_URL}/users/${id}/deactivate`,
    //     CHANGE_PASSWORD: (id) => `${BASE_URL}/users/${id}/change_password`,
    //     RESET_PASSWORD: (id) => `${BASE_URL}/users/${id}/reset_password`,
    // },

    AUTH: {
        LOGIN: `${USERS_BASE}/login`,
        LOGOUT: `${USERS_BASE}/logout`,
        // REFRESH_TOKEN: `${BASE_URL}/refresh_token`,
        // VERIFY_TOKEN: `${BASE_URL}/verify_token`,
    },


};

export default API_ENDPOINTS;